import React, {useState} from "react";
import {MailexCreateRulesStep} from "../upload/steps/MailexCreateRulesStep";
import {MailexUploadRulesDto} from "../../models/MailexUploadRulesDto";
import {LoadingButton} from "@mui/lab";
import {MailSet} from "../../models/MailSet";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {toast} from "react-toastify";
import {RESCHEDULE} from "../../graphql/mutations/gqlReschedule";

interface IModifyMailProps {
	mailSet: MailSet;
}

export const ModifyMail: React.FC<IModifyMailProps> = (props) => {
	const [rules, setRules] = useState<MailexUploadRulesDto>({template: props.mailSet.template, datetime: new Date(props.mailSet.scheduledDateTime)});
	const [formValidated, setFormValidated] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);
	
	const update = () => {
		setSubmitLoading(true);
		
		graphQLServices.mailexClient
			.mutate({
				mutation: RESCHEDULE,
				variables: {
					mailSetId: props.mailSet.id,
					datetime: rules.datetime,
				},
			})
			.then(async (result) => {
				const success = result.data.reschedule.success;
				if (success) {
					toast.success("Modified");
				} else {
					toast.error(result.data.reschedule?.errors[0] ?? "Failed");
				}
			})
			.finally(() =>
				setSubmitLoading(false)
			);
	};
	
	return (
		<div>
			<MailexCreateRulesStep
				rules={rules}
				setRules={setRules}
				validate={() => setFormValidated(true)}
				lockTemplate={true}
			/>
			<LoadingButton
				variant={"contained"}
				disabled={!formValidated}
				loading={submitLoading}
				onClick={() => update()}
			>
				Update
			</LoadingButton>
		</div>
	);
};
